/** The terms of service, on its own URL. */

import { createFileRoute } from '@tanstack/solid-router';
import { DOC_VIEWPORT, DOCS } from '../ui/legal/meta.ts';
import { LegalPage } from '../ui/legal/Page.tsx';
import { Terms } from '../ui/legal/Terms.tsx';

export const Route = createFileRoute('/terms-of-service')({
  /* Lifts the deck's scroll, gesture and zoom locks — see the root document. */
  staticData: { document: true },
  head: () => ({
    meta: [
      { title: DOCS.terms.title },
      { name: 'description', content: DOCS.terms.description },
      { name: 'viewport', content: DOC_VIEWPORT },
    ],
  }),
  component: () => (
    <LegalPage doc="terms">
      <Terms />
    </LegalPage>
  ),
});
